/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UserSummaryViewModel } from "../types/UserSummaryViewModel.ts";
import { userControllerPermissionViewModelSchema } from "./userControllerPermissionViewModelSchema.ts";

export const userSummaryViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do usuário.")),
  userName: z
    .string()
    .describe("Nome de usuário utilizado para autenticação.")
    .nullish(),
  email: z.string().describe("Endereço de e-mail do usuário.").nullish(),
  firstName: z.string().describe("Primeiro nome do usuário.").nullish(),
  lastName: z.string().describe("Sobrenome do usuário.").nullish(),
  roleId: z.optional(
    z
      .number()
      .int()
      .describe(
        "Perfil de acesso do usuário. Enum EUserRole: `1` = Master, `2` = Administrator, `3` = Polo, `4` = Basic, `5` = Relationship, `6` = Planning, `7` = Secretary, `8` = Communication, `9` = Financial, `10` = Visitor, `11` = API, `12` = StudentCare, `13` = Valoriza, `14` = Leads, `15` = Faculty, `16` = Orientation, `17` = Exams, `18` = BusinessCore, `19` = Contracts, `20` = HumanResources, `21` = Audiovisual, `22` = ScholarshipTeam, `23` = Translation, `24` = Transmission, `25` = RelationshipTR, `26` = International.",
      ),
  ),
  permissions: z
    .array(z.lazy(() => userControllerPermissionViewModelSchema))
    .describe(
      "Lista de permissões por controller atribuídas individualmente ao usuário.",
    )
    .nullish(),
}) as unknown as ToZod<UserSummaryViewModel>;
